import * as React from 'react';

const SvgComponent = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 390 390"
    style={{
      enableBackground: 'new 0 0 390 390'
    }}
    xmlSpace="preserve"
    {...props}
  >
    <path d="m23.8 390 135.5-135.6c55.9 44.2 137.6 40.4 189.2-11.1 55.5-55.5 55.6-146 0-201.6s-146.1-55.5-201.6 0c-51.6 51.6-55.4 133.2-11.2 189L-.1 366.3 23.8 390zM167 222.9c-44.3-44.4-44.4-116.7 0-161s116.7-44.4 161 0 44.3 116.7 0 161c-44.4 44.5-116.5 44.5-161 0z" />
  </svg>
);

export default SvgComponent;
